import { render, staticRenderFns } from "./follow_button.vue?vue&type=template&id=0e660b87&scoped=true&"
import script from "./follow_button.vue?vue&type=script&lang=coffee&"
export * from "./follow_button.vue?vue&type=script&lang=coffee&"
import style0 from "./follow_button.vue?vue&type=style&index=0&id=0e660b87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e660b87",
  null
  
)

export default component.exports